module.exports = __webpack_public_path__ + "img/bgcc.eaeafd1b.svg";